import { AdminOrganizationDetails, AdminUserRetrieveOrganization, OrganizationPermissionsEnum, User } from 'api';

export const hasCreateIssuerPermissionOnAtLeastOneOrganization = (user: User | null) =>
  user?.permissionOnAtLeastOneOrganization?.includes(OrganizationPermissionsEnum.CREATE_ISSUERS_VIA_CASHLINK_STUDIO) ??
  false;

export const hasManageUsersAndGroupsOnAtLeastOneOrganization = (user: User | null) =>
  user?.permissionOnAtLeastOneOrganization?.includes(
    OrganizationPermissionsEnum.MANAGE_ORGANIZATION_USERS_AND_GROUPS,
  ) ?? false;

export const currentOrganizationHasManageUsersAndGroupsPermission = (
  organization: AdminOrganizationDetails | AdminUserRetrieveOrganization,
) => organization.permissions.includes(OrganizationPermissionsEnum.MANAGE_ORGANIZATION_USERS_AND_GROUPS) ?? false;

export const currentOrganizationHasManageOrganizationPermission = (
  organization: AdminOrganizationDetails | AdminUserRetrieveOrganization,
) => organization.permissions.includes(OrganizationPermissionsEnum.MANAGE_ORGANIZATION_PERMISSIONS) ?? false;

export const hasViewOrganizationDataPermissionOnAtLeastOneOrganization = (user: User | null) =>
  user?.permissionOnAtLeastOneOrganization?.includes(OrganizationPermissionsEnum.VIEW_ORGANIZATION_DATA) ?? false;

export const currentOrganizationHasCanUseIssuerApiPermission = (
  organization: AdminOrganizationDetails | AdminUserRetrieveOrganization,
) => organization?.permissions.includes(OrganizationPermissionsEnum.CAN_USE_ISSUER_API) ?? false;
